import * as R from "ramda";
import React, { useEffect, useRef } from "react";
import { Card, Col, Row, Spin, Tabs } from "antd";

import { previewMediaOssBaseUrlWithCdn } from "./upload-resource";
import {
  useRawData,
  BaseInfoCard,
} from "@/containers/Video/widgets/base-type-carousel-item-video";

const { TabPane } = Tabs;

export const BaseTypeCarouselItemAudio = (props) => {
  const { loading, rawData, shouldRequest } = useRawData(props);

  const ref = useRef();
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    if (!shouldRequest && ref.current) {
      // noinspection JSUnresolvedReference
      if (!ref.current.paused) {
        // noinspection JSUnresolvedReference
        ref.current.pause();
      }
    }
  }, [shouldRequest, ref]);

  const audioUrl = (() => {
    const path = R.pathOr("", ["item", "path"], rawData);
    if (path.startsWith("//")) {
      return path;
    }
    return previewMediaOssBaseUrlWithCdn + R.pathOr("", ["item", "path"], rawData);
  })();

  if (loading) {
    return <Spin />;
  }

  return (
    <Row
      gutter={16}
      style={{
        maxHeight: "calc(100% - 40px)",
        padding: 20,
      }}
    >
      <Col span={16}>
        <div className="flex-x-center flex-y-center">
          <audio ref={ref} controls src={audioUrl} />
        </div>
      </Col>
      <Col span={8}>
        <Tabs defaultActiveKey="1" type="card" className="bg-white h-full">
          <TabPane tab="详情" key="1">
            <BaseInfoCard rawData={rawData} {...props} />
          </TabPane>
          <TabPane tab="语音识别" key="2">
            <Card>
              <Row gutter={16}>
                <Col span={8}>
                  <strong>比特率:</strong>
                </Col>
                <Col span={16}>
                  {R.pathOr(
                    "",
                    [
                      "aliyuninfo",
                      "FileInfoList",
                      0,
                      "AudioStreamInfoList",
                      0,
                      "Bitrate",
                    ],
                    rawData
                  )}
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <strong>声道布局:</strong>
                </Col>
                <Col span={16}>
                  {R.pathOr(
                    "",
                    [
                      "aliyuninfo",
                      "FileInfoList",
                      0,
                      "AudioStreamInfoList",
                      0,
                      "ChannelLayout",
                    ],
                    rawData
                  )}
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <strong>声道数:</strong>
                </Col>
                <Col span={16}>
                  {R.pathOr(
                    "",
                    [
                      "aliyuninfo",
                      "FileInfoList",
                      0,
                      "AudioStreamInfoList",
                      0,
                      "Channels",
                    ],
                    rawData
                  )}
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <strong>编码器:</strong>
                </Col>
                <Col span={16}>
                  {R.pathOr(
                    "",
                    [
                      "aliyuninfo",
                      "FileInfoList",
                      0,
                      "AudioStreamInfoList",
                      0,
                      "CodecLongName",
                    ],
                    rawData
                  )}
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <strong>采样率:</strong>
                </Col>
                <Col span={16}>
                  {R.pathOr(
                    "",
                    [
                      "aliyuninfo",
                      "FileInfoList",
                      0,
                      "AudioStreamInfoList",
                      0,
                      "SampleRate",
                    ],
                    rawData
                  )}
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <strong>时长:</strong>
                </Col>
                <Col span={16}>
                  {R.pathOr(
                    "",
                    [
                      "aliyuninfo",
                      "FileInfoList",
                      0,
                      "AudioStreamInfoList",
                      0,
                      "Duration",
                    ],
                    rawData
                  )}
                </Col>
              </Row>
            </Card>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/base-type-carousel-item-audio.js